// extracted by mini-css-extract-plugin
export default {"l_click_encourage_container":"TextareaOverlaySet_l_click_encourage_container__K+L76"};